import { all, call } from "redux-saga/effects";

import { adminSaga } from "../modules/admin";
import { flowerStandSaga } from "../modules/flowerStand";
import { liveSaga } from "../modules/live";
import { newsSaga } from "../modules/news";
import { notificationSaga } from "../modules/notification";
import { streamingSaga } from "../modules/streaming";
import { authSaga } from "./auth";
import { cartSaga } from "./cart";
import { eventSaga } from "./event";
import { firestoreSaga } from "./firestore";
import { purchaseSaga } from "./purchase";
import { ticketSaga } from "./ticket";

export default function* indexSaga() {
  yield all([
    call(eventSaga),
    call(authSaga),
    call(firestoreSaga),
    call(ticketSaga),
    call(cartSaga),
    call(purchaseSaga),
    call(flowerStandSaga),
    call(adminSaga),
    call(liveSaga),
    call(streamingSaga),
    call(newsSaga),
    call(notificationSaga),
  ]);
}
